import { IonButton, IonButtons, IonCol, IonContent, IonGrid, IonIcon, IonPage, IonRow, IonToolbar } from '@ionic/react';
import { addOutline } from 'ionicons/icons';
import Footer from '../../components/Footer';
import { User } from '../../models/data';
import { translation } from '../../models/translation';
import FundraiseList from './FundraiseList';
import { OptionPages } from '../../models/apiModels';
import { fetchOptions } from '../../services/options_service';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import Meta from '../../components/Meta';

interface Props {
  user: User | null
}

const FundraiseHome: React.FC<Props> = ({ user }) => {

  const siteText = translation();
  const lan = siteText.lan.replace("/", "")
  const pathName = useLocation().pathname;

  const isAccountPage = () => {
    if (pathName.indexOf('account') < 0) return false;
    return true
  }

  const [siteOptions, setSiteOptions] = useState<OptionPages>();

  useEffect(() => {
    getOptions()
  }, [])

  const getOptions = async () => {
    let resp: any = await fetchOptions();
    if (!resp.error) {
      let options: OptionPages = resp.message;
      setSiteOptions(options);
    }
  }


  return (
    <IonPage className='pageContent'>
      {siteText.lan === '/en' && <Meta url={window.location.href} description={`${siteOptions?.acf.fundraise_heading_description.en.seo_description}`} title={`${siteOptions?.acf.fundraise_heading_description.en.seo_title}`} ></Meta>}
      {siteText.lan === '/fr' && <Meta url={window.location.href} description={`${siteOptions?.acf.fundraise_heading_description.fr.seo_description}`} title={`${siteOptions?.acf.fundraise_heading_description.fr.seo_title}`} ></Meta>}
      {siteText.lan === '/de' && <Meta url={window.location.href} description={`${siteOptions?.acf.fundraise_heading_description.de.seo_description}`} title={`${siteOptions?.acf.fundraise_heading_description.de.seo_title}`} ></Meta>}
      <IonContent>
        <IonGrid className={!isAccountPage() ? ' sw_sp_md' : ' accountSectionSpacingBottom'}>
          <IonRow>
            <IonCol offset='1' size='10' >
              {lan === "en" && <>
                <h1 className='ion-text-uppercase'>+{siteOptions?.acf.fundraise_heading_description.en.heading ?? siteText.fundraiseTitle}</h1>
                <p dangerouslySetInnerHTML={{ __html: siteOptions?.acf.fundraise_heading_description.en.description ?? '' }}></p>
              </>}
              {lan === "fr" && <>
                <h1 className='ion-text-uppercase'>+{siteOptions?.acf.fundraise_heading_description.fr.heading ?? siteText.fundraiseTitle}</h1>
                <p dangerouslySetInnerHTML={{ __html: siteOptions?.acf.fundraise_heading_description.fr.description ?? '' }}></p>
              </>}
              {lan === "de" && <>
                <h1 className='ion-text-uppercase'>+{siteOptions?.acf.fundraise_heading_description.de.heading ?? siteText.fundraiseTitle}</h1>
                <p dangerouslySetInnerHTML={{ __html: siteOptions?.acf.fundraise_heading_description.de.description ?? '' }}></p>
              </>}
            </IonCol>
          </IonRow>
          <IonRow>
            {user && <IonCol offset='1' size='10'>
              <IonToolbar mode='md' >
                <IonButtons className='fundraiserTabs'>
                  <IonButton routerLink='#' className='active'>{siteText.fundraiseAllSectTitle}</IonButton>
                  <IonButton routerLink={siteText.lan + '/account/fundraisersbyuser'}>{siteText.fundraiseUserSectTitle}</IonButton>
                  <IonButton routerLink={siteText.lan + '/account/fundraisercreate'} color='primary' fill='clear'>{siteText.fundraiseCreateTitle}<IonIcon icon={addOutline} /></IonButton>
                </IonButtons>
              </IonToolbar>
            </IonCol>}
          </IonRow>
          <FundraiseList></FundraiseList>
        </IonGrid>

        <Footer></Footer>
      </IonContent>
    </IonPage>
  );

};

export default FundraiseHome;
